module.exports = __webpack_public_path__ + "img/20180103_114717-1.060016aa.jpg";